import classNames from 'classnames';
import React from 'react';
import styles from './FollowUpChats.module.css';

type Props = {
  count: number;
  showFullValue?: boolean;
  css?: {
    wrapper?: string;
    value?: string;
  };
};

export const FollowUpChats = (props: Props) => {
  const { count, showFullValue = true, css } = props;
  if (count <= 0) {
    return <></>;
  }
  return (
    <div className={classNames(styles.wrapper, css?.wrapper)}>
      <div className={classNames(styles.value, css?.value)}>
        {showFullValue ? count : count > 20 ? '20+' : count}
      </div>
    </div>
  );
};
